<template>
    <v-list
        component="ShortlistCharacterList"
        :style="{ background: `${getColorById(characterIn.farba)}!important` }"
        :class="[{ isSmallScreen: getIsSmallScreen }, { isSmallerScreen: getIsSmallerScreen }]"
    >
        <div class="empty" v-if="!candidateList.length">Drop voices here</div>
        <draggable
            v-bind="dragOptions"
            group="people"
            :list="candidateList"
            @start="checkMove"
            @add="onAdd"
            @sort="onSort"
            :disabled="projectWasClosed"
            :component-data="{ attrs: { character: characterIn.id } }"
        >
            <shortlist-character-list-item
                v-for="(candidate, index) in candidateList"
                :key="`candidate-${candidate.id}-${index}`"
                :index="index"
                :candidateIn="candidate"
                :character="characterIn"
                :voice="candidate.id"
                @removeFromList="removeFromList"
            />
        </draggable>
    </v-list>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import ShortlistCharacterListItem from './ShortlistCharacterListItem.vue';

export default {
    name: 'Shortlist',

    props: {
        characterIn: {},
    },

    data() {
        return {
            removeConfirm: false,
            candidates: [],
            character: [],
            first_change: true,
            dragOptions: {
                ghostClass: 'ghost',
            },
            immediate: true,
        };
    },

    created() {
        this.character = this.characterIn;
        this.candidates = this.character.candidates;
    },

    async mounted() {
        this.loading = false;
    },

    methods: {
        ...mapActions(['updateCharacter']),
        ...mapMutations(['setCharacterToActor']),

        removeFromList({ index, candidate }) {
            this.candidateList.splice(index, 1);
            this.updateCharacter(this.character);
            this.setCharacterToActor({
                voiceId: parseInt(candidate.id),
                characterId: null,
            });
        },

        onAdd(evt) {
            this.setCharacterToActor({
                voiceId: parseInt(evt.item.getAttribute('voice')),
                characterId: parseInt(evt.to.getAttribute('character')),
            });
        },

        onSort() {
            this.updateCharacter(this.character);
        },

        checkMove(evt) {
            // odrb na blikanie ghostu v cieli dropovania
            evt.item.style.display = 'flex';
        },
    },

    computed: {
        ...mapGetters(['getColorById', 'getIsSmallScreen', 'getIsSmallerScreen', 'projectWasClosed']),

        candidateList: {
            get() {
                return this.candidates;
            },
            set(value) {
                this.candidates = value;
            },
        },
    },

    watch: {},

    components: {
        draggable,
        Mp3Player,
        ShortlistCharacterListItem,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

.ghost {
    opacity: 0.5;
    background-color: white;
    border: none;
    display: none;
}
[component='ShortlistCharacterList'] {
    padding: 0;
    overflow: hidden;
    min-height: 40px;

    &.isSmallScreen {
        min-height: 33px;
    }

    .empty {
        position: absolute;
        .flex-row;
        font-size: 13px;
        left: 0;
        padding-left: 15px;
        width: 100%;
        height: 40px;
        pointer-events: none;
        background-color: fade(white, 30%);
        color: fade(black, 50%);
    }
}
</style>
